<!-- 工作台--沟通列表--编辑报告--人才推荐报告 -->
<template>
  <div class="referenceCheck">
    <div class="form_content">
      <el-form :model="basicInfoObj" label-width="120px">
        <!-- 公司信息 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">公司信息</div>
        </div>
        <!-- <title-bar title="公司信息" /> -->
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="公司名称：">
              <el-input v-model="basicInfoObj.corporateName" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="人才供应商：">
              <el-input v-model="basicInfoObj.talentSupplier" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="应聘职位：">
              <el-input v-model="basicInfoObj.recruitmentPosition" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目顾问：">
              <el-input v-model="basicInfoObj.projectConsultant" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="日期：">
              <el-input v-model="basicInfoObj.dateTime" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="form" ref="form" :rules="ruleForm" label-width="120px">
        <!-- 个人信息 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">个人信息</div>
        </div>
        <div class="personal_information">
          <el-form-item label="姓名：">
            <el-input class="personal_information_name" readonly v-model="form.name" placeholder="请输入" />
          </el-form-item>

          <el-form-item label="年龄：">
            <el-input class="personal_information_age" readonly v-model="form.age" placeholder="请输入" />
          </el-form-item>

          <el-form-item label="语言能力：">
            <el-input class="personal_information_lang" v-model="form.languageAbility" readonly placeholder="请输入" />
          </el-form-item>

          <el-form-item label="婚姻状况：">
            <el-radio-group v-model="form.weddingOrNot">
              <el-radio :label="1">未婚</el-radio>
              <el-radio :label="0">已婚</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所在地：" class="CascaderArea" label-width="180px">
            <CascaderArea :country="form.personCountry" :province="form.personProvince" :city="form.personCity">
            </CascaderArea>
          </el-form-item>
        </div>

        <!-- 人才评估 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">人才评估</div>
        </div>
        <div class="talent_evaluation">
          <el-form-item class="is-required" label=" " prop="selectByidObj.talentEvaluation" :rules="[
            {
              validator: (rules, value, callback) => {
                validatorEvaluation(rules, value, callback)
              },
              trigger: 'blur',
              required: true
            }
          ]">
            <el-input type="textarea" :rows="4" v-model="form.selectByidObj.talentEvaluation" placeholder="" resize="none"
              class="fix-input" @input="(value) => onChangeSelectByidObj(value, 'talentEvaluation')" />
          </el-form-item>
        </div>

        <!-- 教育背景 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">教育背景</div>
        </div>
        <div class="educational_background">
          <div class="educational_background_item" v-for="(item, index) in form.personEducational" :key="index">
            <!-- 开始年月 -->
            <div class="start_time">
              <el-form-item>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.startDate" type="date"
                  placeholder="请输入年/月" />
              </el-form-item>
            </div>
            <span style="margin: 0 6px"> ~ </span>
            <!-- 结束年月 -->
            <div class="end_time">
              <el-form-item>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.endDate" type="date"
                  placeholder="请输入年/月" />
              </el-form-item>
            </div>
            <!-- 学校 -->
            <div class="school">
              <el-form-item>
                <el-input v-model="item.schoolName" readonly></el-input>
              </el-form-item>
            </div>
            <!-- 学校所在城市 -->
            <div style="margin-right: 8px">
              <el-form-item>
                <el-input v-model="item.cityName" placeholder="请输入城市" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </div>
            <!-- 学位 -->
            <div class="degree">
              <el-form-item>
                <el-select v-model="item.education" placeholder="学位">
                  <el-option label="中专" value="中专"></el-option>
                  <el-option label="研究生" value="研究生"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="博士" value="博士"></el-option>
                  <el-option label="博士后" value="博士后"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- 专业 -->
            <div class="specialty">
              <el-form-item>
                <el-input v-model="item.major" readonly></el-input>
              </el-form-item>
            </div>

            <!-- <div class="options_item">
            <div class="add_item" @click="clickAddPersonEducationalItem(item, index)">
              <div class="add_icon">
                <i style="color: #17757a; font-size: 17px" class="el-icon-circle-plus-outline"></i>
              </div>
              <div class="add_txt">添加</div>
            </div>

            <div
              class="remove_item"
              v-if="index >= 1"
              @click="clickRemovePersonEducationalItem(item, index)"
            >
              <div class="remove_icon">
                <i style="color: #fa5050; font-size: 17px" class="el-icon-delete"></i>
              </div>
              <div class="remove_txt">删除</div>
            </div>
          </div> -->
          </div>
        </div>

        <!-- 工作经历及内容 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">工作经历及内容</div>
          <!-- <div class="add_item">
          <div class="add_item_box" @click="clickAddPersonDetailsWorkExperiences">
            <div class="add_icon">
              <i style="color: #17757a; font-size: 17px" class="el-icon-circle-plus-outline"></i>
            </div>
            <div class="add_txt" style="color: #17757a">添加</div>
          </div>
        </div> -->
        </div>

        <div class="work_experience_content fix-input">
          <!-- 循环模板 -->
          <div v-show="editWorkExperience">
            <div class="work_experience_content_item" v-for="(item, index) in form.personExperience" :key="index">
              <div class="head_time">
                <div class="head_time_box">
                  <div class="times">{{ item.inductionTime }}~{{ item.quitTime }}</div>
                  <div class="name">{{ item.companyName }}</div>
                </div>
                <div class="head_time_option">
                  <div style="color: #17757a; margin-right: 20px; cursor: pointer"
                    @click="clickRedactPersonExperience(item, index)">
                    <i class="iconfont icon-jr-icon-modify"></i>编辑
                  </div>
                  <div style="color: rgb(250, 80, 80); cursor: pointer" @click="clickRemovePersonExperience(item, index)">
                    <i class="iconfont icon-jr-icon-delete"></i>删除
                  </div>
                </div>
              </div>

              <div class="content">
                <div class="label">职位：</div>
                <div class="content_right">
                  <div class="content_position">{{ item.position }}</div>
                </div>
              </div>

              <div class="content" style="margin-top: 10px">
                <div class="label">职位内容：</div>
                <div class="content_right">
                  <div class="operatingDuty" style="white-space: pre-line">
                    {{ item.operatingDuty }}
                  </div>
                </div>
              </div>

              <div class="content" styl内e="margin-top: 10px">
                <div class="label">职位业绩：</div>
                <div class="content_right">
                  <div class="operatingDuty" style="white-space: pre-line; margin: 20px 0">
                    {{ item.jobPerformance }}
                  </div>
                </div>
              </div>

              <div class="content" style="margin-top: 10px">
                <div class="label">离职原因：</div>
                <div class="content_right">
                  <div class="operatingDuty" style="white-space: pre-line">
                    {{ item.reasonsLeaving }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 添加模板 -->
          <div class="add_personExperience" v-show="personExperienceShow">
            <div class="add_personExperience_head">
              <el-form-item label="在职时间：" label-width="84px">
                <el-date-picker v-model="personExperienceList.inductionTime" type="month" placeholder="选择日期"
                  style="width: 140px" value-format="yyyy-MM">
                </el-date-picker>
                <span style="margin: 0 4px">~ </span>
                <el-date-picker v-model="personExperienceList.quitTime" type="month" placeholder="至今"
                  value-format="yyyy-MM" style="width: 140px; margin-right: 10px">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="公司名称：">
                <el-input style="width: 281px" v-model="personExperienceList.companyName"></el-input>
              </el-form-item>

              <el-form-item label="职位：" label-width="100px">
                <el-input style="width: 281px" v-model="personExperienceList.position"></el-input>
              </el-form-item>

              <el-form-item label="地点：" label-width="100px">
                <el-input style="width: 281px" v-model="personExperienceList.location"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_center">
              <el-form-item label="职位内容：" style="margin-bottom: 10px" label-width="84px">
                <el-input v-model="personExperienceList.operatingDuty" type="textarea"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_center">
              <el-form-item label="职位业绩：" style="margin: 10px 0" label-width="84px">
                <el-input v-model="personExperienceList.jobPerformance" type="textarea"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_center">
              <el-form-item label="离职原因：" style="margin-bottom: 0" label-width="84px">
                <el-input v-model="personExperienceList.reasonsLeaving" type="textarea"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_option">
              <div class="cancel" @click="clickCancel">取消</div>
              <div class="accomplish" @click="clickAccomplish">完成</div>
            </div>
          </div>
        </div>

        <!-- og -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">部分项目</div>
          <div class="add_item">
            <!-- <div class="add_item_box" @click="addPersonProjectExperience">
            <div class="add_icon">
              <i style="color: #17757a; font-size: 17px" class="el-icon-circle-plus-outline"></i>
            </div>
            <div class="add_txt" style="color: #17757a">添加</div>
          </div> -->
          </div>
        </div>

        <div class="work_experience_content">
          <!-- 循环模板 -->
          <div class="work_experience_content_item" v-for="(item, index) in form.personProjectExperience" :key="index">
            <div class="head_time">
              <div class="head_time_box">
                <div class="times">{{ item.startTime }}~{{ item.endTime }}</div>
                <div class="name">{{ item.projectName }}</div>
              </div>
              <div class="head_time_option">
                <!-- <div
                style="color: #17757a; margin-right: 20px; cursor: pointer"
                @click="clickRedactPersonProjectExperience(item, index)"
              >
                <i class="iconfont icon-jr-icon-modify"></i>编辑
              </div>
              <div
                style="color: rgb(250, 80, 80); cursor: pointer"
                @click="clickRemovePersonProjectExperience(item, index)"
              >
                <i class="iconfont icon-jr-icon-delete"></i>删除
              </div> -->
              </div>
            </div>

            <div class="content">
              <div class="label">项目描述:</div>
              <div class="content_right">
                <div class="content_position">{{ item.projectFunction }}</div>
                <div class="operatingDuty" style="white-space: pre-line">
                  {{ item.projectAchievement }}
                </div>
              </div>
            </div>
          </div>

          <!-- 添加模板 -->
          <div class="add_personExperience" v-show="addPersonProjectExperienceShow">
            <div class="add_personExperience_head">
              <el-form-item label="在职时间：" label-width="84px">
                <el-date-picker v-model="personProjectExperienceList.inductionTime" type="month" placeholder="选择日期"
                  style="width: 140px" value-format="yyyy-MM">
                </el-date-picker>
                <span style="margin: 0 4px">~ </span>
                <el-date-picker v-model="personProjectExperienceList.quitTime" type="month" placeholder="至今"
                  value-format="yyyy-MM" style="width: 140px; margin-right: 10px">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="公司名称：">
                <el-input style="width: 281px" v-model="personProjectExperienceList.companyName"></el-input>
              </el-form-item>

              <el-form-item label="职位：" label-width="100px">
                <el-input style="width: 281px" v-model="personProjectExperienceList.position"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_center">
              <el-form-item label="项目描述：" style="margin-bottom: 0" label-width="84px">
                <el-input v-model="personProjectExperienceList.operatingDuty" type="textarea"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_option">
              <div class="cancel" @click="clickCancelTwo">取消</div>
              <div class="accomplish" @click="clickAccomplishTwo">完成</div>
            </div>
          </div>
        </div>

        <!-- 部分项目 -->
        <!-- <div class="title_main">
        <div class="line"></div>
        <div class="title_main_txt">部分项目</div>
      </div>
      <div class="some_projects">
        <el-form-item>
          <el-input v-model="form.name" type="textarea" resize="none"> </el-input>
        </el-form-item>
      </div> -->

        <!-- 技术能力 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">技术能力</div>
        </div>
        <div class="some_projects">
          <el-form-item>
            <!-- <el-input v-model="form.name" type="textarea" resize="none"> </el-input> -->
            <div style="margin: 0 0 0 30px">
              <el-tag :key="index + 50" v-for="(tag, index) in form.listTechnique" :disable-transitions="false"
                @close="handleCloseTech(tag)">
                {{ tag }}
              </el-tag>
              <el-input class="input-new-tag small_input" v-if="inputVisibleTech" v-model="inputValueTech"
                ref="saveTagInputTech" size="small" @keyup.enter.native="handleInputConfirmTech"
                @blur="handleInputConfirmTech">
              </el-input>
              <!-- <el-button v-else class="button-new-tag" size="small" @click="showInputTech"
              >添加标签</el-button
            > -->
            </div>
          </el-form-item>
        </div>

        <!-- 职业培训 -->
        <!-- <div class="title_main">
        <div class="line"></div>
        <div class="title_main_txt">职业培训</div>
      </div>
      <div class="some_projects">
        <el-form-item>
          <el-input v-model="form.name" type="textarea" resize="none"> </el-input>
        </el-form-item>
      </div> -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">职业培训</div>
          <div class="add_item">
            <!-- <div class="add_item_box" @click="openVocationalTrainingsShow">
            <div class="add_icon">
              <i style="color: #17757a; font-size: 17px" class="el-icon-circle-plus-outline"></i>
            </div>
            <div class="add_txt" style="color: #17757a">添加</div>
          </div> -->
          </div>
        </div>

        <div class="work_experience_content">
          <!-- 循环模板 -->
          <div class="work_experience_content_item" v-for="(item, index) in form.vocationalTrainings" :key="index">
            <div class="head_time">
              <div class="head_time_box">
                <div class="times">{{ item.inductionTime }}~{{ item.quitTime }}</div>
                <div class="name">{{ item.companyName }}</div>
              </div>
              <div class="head_time_option">
                <div style="color: #17757a; margin-right: 20px; cursor: pointer"
                  @click="clickRedactPersonVocationalTrainings(item, index)">
                  <i class="iconfont icon-jr-icon-modify"></i>编辑
                </div>
                <div style="color: rgb(250, 80, 80); cursor: pointer"
                  @click="clickRemovePersonProjectExperience(item, index)">
                  <i class="iconfont icon-jr-icon-delete"></i>删除
                </div>
              </div>
            </div>

            <div class="content">
              <div class="label">项目描述:</div>
              <div class="content_right">
                <div class="content_position">{{ item.position }}</div>
                <div class="operatingDuty" style="white-space: pre-line">
                  {{ item.operatingDuty }}
                </div>
              </div>
            </div>
          </div>

          <!-- 添加模板 -->
          <div class="add_personExperience" v-show="vocationalTrainingsShow">
            <div class="add_personExperience_head">
              <el-form-item label="培训时间：" label-width="84px">
                <el-date-picker v-model="vocationalTrainingsList.startTime" type="month" placeholder="选择日期"
                  style="width: 140px" value-format="yyyy-MM">
                </el-date-picker>
                <span style="margin: 0 4px">~ </span>
                <el-date-picker v-model="vocationalTrainingsList.endTime" type="month" placeholder="至今"
                  value-format="yyyy-MM" style="width: 140px; margin-right: 10px">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="培训主题：" label-width="84px">
                <el-input style="width: 281px" v-model="vocationalTrainingsList.trainingTopics"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="培训地点：" label-width="100px">
              <el-input v-model="vocationalTrainingsList.address" style="width: 400px"></el-input>
            </el-form-item>
            <div class="add_personExperience_center">
              <el-form-item label="培训内容" style="margin-bottom: 0" label-width="84px">
                <el-input v-model="vocationalTrainingsList.trainingContent" type="textarea"></el-input>
              </el-form-item>
            </div>
            <div class="add_personExperience_option">
              <!-- vocationalTrainings -->
              <div class="cancel" @click="clickVocationalTrainingsTwo">取消</div>
              <div class="accomplish" @click="clickVocationalTrainings">完成</div>
            </div>
          </div>
        </div>

        <!-- log -->

        <!-- 专业认证  certifications-->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">专业认证</div>
          <div class="add_item">
            <!-- <div class="add_item_box" @click="addCertifications">
            <div class="add_icon">
              <i style="color: #17757a; font-size: 17px" class="el-icon-circle-plus-outline"></i>
            </div>
            <div class="add_txt" style="color: #17757a">添加</div>
          </div> -->
          </div>
        </div>
        <!-- <div class="some_projects">
        <el-form-item>
          <el-input v-model="form.name" type="textarea" resize="none"> </el-input>
        </el-form-item>
      </div> -->
        <div class="educational_background">
          <div class="educational_background_item" v-for="(item, index) in form.certifications" :key="index">
            <!-- 开始年月 -->
            <div class="start_time">
              <el-form-item>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.startTime" type="date"
                  placeholder="请选择日期" />
              </el-form-item>
            </div>
            <span style="margin: 0 6px"> ~ </span>
            <!-- 结束年月 -->
            <div class="end_time">
              <el-form-item>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.endTime" type="date"
                  placeholder="请选择日期" />
              </el-form-item>
            </div>
            <!-- 学校 -->
            <div class="school">
              <el-form-item>
                <el-input v-model="item.address" placeholder="请输入地点"></el-input>
              </el-form-item>
            </div>

            <!-- 专业 -->
            <div class="specialty">
              <el-form-item>
                <el-input v-model="item.certificateName" placeholder="请输入专业证书"></el-input>
              </el-form-item>
            </div>

            <div class="options_item">
              <div class="remove_item" @click="removeCertifications(item, index)">
                <div class="remove_icon">
                  <i style="color: #fa5050; font-size: 17px" class="el-icon-delete"></i>
                </div>
                <div class="remove_txt">删除</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 业界荣誉 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">业界荣誉</div>
        </div>
        <div class="some_projects">
          <el-form-item>
            <el-input v-model="form.honor" :rows="4" readonly type="textarea" resize="none" class="fix-input">
            </el-input>
          </el-form-item>
        </div>

        <!-- 目前薪资 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">目前薪资</div>
        </div>
        <div class="current_salary">
          <el-form-item class="new_left" label=" " prop="selectByidObj.curSalaryItems" :rules="[
            {
              validator: (rules, value, callback) => {
                validatorCurSalaryItems(rules, callback)
              },
              trigger: 'blur',
              required: true
            }
          ]">
            <div class="menony_flex">
              <div class="menony_flex_left">
                <div class="menony_flex_item">
                  <span v-if="form.isAnnual == 1" class="star_style">年薪：</span>
                  <span v-else class="star_style">月薪：</span>
                  <el-input v-model="selectByidObj.currentSalary" />
                </div>
              </div>
              <div class="menony_flex_center">
                <span>薪资构成</span>
                <div></div>
              </div>
              <div class="menony_flex_right">
                <div class="menony_flex_right_li">
                  <div class="menony_flex_item">
                    <span class="star_style">固定月薪：</span>
                    <el-input v-model="selectByidObj.currentMonthlySalary" placeholder="请输入数字"
                      oninput="value=value.replace(/^0|[^0-9]/g, '')" />
                  </div>
                  <!-- <div class="menony_flex_item">
                  <span>月份：</span>
                  <el-input
                    v-model="selectByidObj.currentMonthlySalary"
                    placeholder="请输入数字"
                    oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  />
                </div> -->
                  <div class="menony_flex_item">
                    <span class="star_style">年度奖金：</span>
                    <el-input v-model="selectByidObj.currentAnnualBonus" />
                  </div>
                </div>
                <div class="menony_flex_right_li">
                  <div class="menony_flex_item">
                    <span class="star_style">绩效奖金：</span>
                    <el-input v-model="selectByidObj.currentPerformanceBonus" />
                  </div>
                  <div class="menony_flex_item">
                    <span class="star_style">提成：</span>
                    <el-input v-model="selectByidObj.currentPercentage" />
                  </div>
                </div>
                <div class="menony_flex_right_li">
                  <div class="menony_flex_right_li_item">
                    <span class="star_style">其他：</span>
                    <el-input v-model="selectByidObj.currentOther" type="textarea" :rows="3" />
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 期望薪资 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">期望薪资</div>
        </div>
        <div class="current_salary">
          <el-form-item class="new_left" label=" " prop="selectByidObj.salaryExpectationItems" :rules="[
            {
              validator: (rules, value, callback) => {
                validatorExpectationtems(rules, callback)
              },
              trigger: 'blur',
              required: true
            }
          ]">
            <div class="menony_flex">
              <div class="menony_flex_left">
                <div class="menony_flex_item">
                  <span v-if="form.isAnnual == 1" class="star_style">年薪：</span>
                  <span v-else class="star_style">月薪：</span>
                  <el-input v-model="selectByidObj.salaryExpectation" />
                </div>
              </div>
              <div class="menony_flex_center">
                <span class="star_style">薪资构成</span>
                <div></div>
              </div>
              <div class="menony_flex_right">
                <div class="menony_flex_right_li">
                  <div class="menony_flex_item">
                    <span class="star_style">固定月薪：</span>
                    <el-input v-model="selectByidObj.salaryMonthlySalary" placeholder="请输入数字"
                      oninput="value=value.replace(/^0|[^0-9]/g, '')" />
                  </div>
                  <!-- <div class="menony_flex_item">
                  <span>月份：</span>
                  <el-input
                    v-model="selectByidObj.currentMonthlySalary"
                    placeholder="请输入数字"
                    oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  />
                </div> -->
                  <div class="menony_flex_item">
                    <span class="star_style">年度奖金：</span>
                    <el-input v-model="selectByidObj.salaryAnnualBonus" />
                  </div>
                </div>
                <div class="menony_flex_right_li">
                  <div class="menony_flex_item">
                    <span class="star_style">绩效奖金：</span>
                    <el-input v-model="selectByidObj.salaryPerformanceBonus" />
                  </div>
                  <div class="menony_flex_item">
                    <span class="star_style">提成：</span>
                    <el-input v-model="selectByidObj.salaryPercentage" />
                  </div>
                </div>
                <div class="menony_flex_right_li">
                  <div class="menony_flex_right_li_item">
                    <span class="star_style">其他：</span>
                    <el-input v-model="selectByidObj.salaryOther" type="textarea" :rows="3" />
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 入职时间 -->
        <div class="entryTime">
          <el-form-item label="入职时间：" class="is-required" prop="entryTime">
            <el-input style="width: 119px" v-model="form.entryTime" placeholder="请输入"></el-input>
            <el-radio-group v-model="form.timeChoose" style="margin-left: 10px">
              <el-radio-button :label="0">一个月离职通知</el-radio-button>
              <el-radio-button :label="1">随时</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 操作 -->
    <div class="option_button">
      <!-- 保存 -->
      <div class="save" @click="save" v-if="showAutingBtn == '0'">保存</div>
      <!-- 下载 -->
      <div class="download" @click="download" v-if="showAutingBtn == '0'">下载报告</div>
      <!-- 返回上一页 -->
      <div class="back" @click="onBack" v-if="showAutingBtn == '0'">返回上级</div>
      <div class="save" @click="auditingNoY(item)" v-if="showAutingBtn == '1'">审核通过</div>
      <!-- 返回上一页 -->
      <div class="back" @click="auditingNo" v-if="showAutingBtn == '1'">审核不通过</div>
    </div>
    <!-- 审核不通过弹窗 -->
    <el-dialog :visible.sync="auditingNoDialogVisible" width="40%" :before-close="handleCloseA">
      <div class="auditingNo">
        <div class="title"><span></span><span>审核不通过</span></div>
      </div>
      <div style="padding: 50px 50px 0 40px">
        <el-form label-position="left" label-width="100px" :model="auditingNoForm" :rules="auditingNoRules">
          <div style="display: flex">
            <el-form-item label="驳回理由：" prop="rejectionReason">
              <el-select v-model="auditingNoForm.rejectionReason" placeholder="请选择" @change="rejectionReasonChange"
                clearable :disabled="auditingDisabled">
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="info">
                <el-radio :label="1" :disabled="rejectionDisabled" @click.native="pendingRes($event)">自定义理由</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="驳回理由：" v-if="info == 1">
            <el-input v-model="auditingNoForm.rejectionReason" type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditingNoFn">保 存</el-button>
        <el-button @click="handleCloseA">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { create } from 'lodash'
import CascaderArea from '../../../../components/CascaderArea.vue'
import {
  getParticularsPersonByid,
  selectByid,
  addTalentRecommend,
  reportDownLoad
} from '@/api/projectCenter.js'
import { agree, reject, rejectionType } from '@/api/jingyiProject.js'
import log from 'echarts/src/scale/Log'

export default {
  props: {
    PreCode: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    reviewCode: {
      type: String
    },
    showAutingBtn: {
      type: Number
    },
    // 项目id
    projectCode: {
      type: String
    },
    projectId: {
      type: String
    }
  },

  components: {
    CascaderArea
  },
  created() {
    this.search()
    // this.getSelectByid()
    this.getRejectionType()
    this.basicInfoObj.corporateName = this.item.corporateName
    this.basicInfoObj.recruitmentPosition = this.item.recruitmentPosition
    // if (this.item.projectManagers) {
    //   let projectConsultant = this.item.projectManagers.join(',')
    //   this.basicInfoObj.projectConsultant = projectConsultant
    // }
  },
  computed: {},

  data() {
    return {
      auditingDisabled: false, //控制驳回理由下拉状态
      rejectionDisabled: false, //控制自定义理由状态
      auditingNoDialogVisible: false, //审核不通过弹窗显示
      options: [], //驳回理由数据
      radio: 0, //驳回理由
      //审核不通过表单数据
      info: 0, //是否显示自定义驳回理由
      auditingNoForm: {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      },
      //审核不通过表单校验
      auditingNoRules: {
        rejectionReason: [{ required: true, message: '请选择驳回理由', trigger: 'change' }]
      },
      // -
      btnClickCount: {
        save: 0, // 保存按钮
        download: 0 // 下载按钮
      },
      basicInfoObj: {
        corporateName: '', // 公司名称
        talentSupplier: '菁锐人才', // 人才供应商
        recruitmentPosition: '', // 应聘职位
        projectConsultant: '', // 项目顾问
        dateTime: this.$df(new Date().getTime(), 'yyyy-mm-dd') // 日期
      },
      addPersonProjectExperienceShow: false,
      selectByidObj: {
        createName: '',
        createTime: '',
        currentAnnualBonus: '',
        currentMonthlySalary: '',
        currentOther: '',
        currentPercentage: '',
        currentPerformanceBonus: '',
        currentSalary: '',
        id: '',
        personnelId: '',
        salaryAnnualBonus: '',
        salaryExpectation: '',
        salaryMonthlySalary: '',
        salaryOther: '',
        salaryPercentage: '',
        salaryPerformanceBonus: '',
        talentEvaluation: '', //人才评估
        updateName: '',
        updateTime: ''
      },
      // 工作经历判断条件
      personExperienceShow: false,
      form: {
        selectByidObj: {
          talentEvaluation: '', //人才评估
          curSalaryItems: '', //用来校验当前薪资字段
          salaryExpectationItems: '' //用来校验期望薪资字段
        },
        // 年龄
        age: '',
        // 专业认证
        certifications: [
          {
            address: '',
            certificateName: '',
            createName: '',
            createTime: '',
            endTime: 'yyyy-MM',
            id: 0,
            personnelCode: '',
            startTime: 'yyyy-MM',
            updateName: '',
            updateTime: ''
          }
        ],
        // 创建人名字
        createName: '',
        // 创建时间
        createTime: '',
        // 所在行业
        currentIndustry: '',
        // 目前薪资始终
        currentSalaryEnd: '',
        // 目前薪资起
        currentSalaryStart: '',
        // 教育背景
        educationBackground: '',
        // 入职时间
        entryTime: '',
        // 期望城市
        expectedCity: '',
        // 期望国家
        expectedCountry: '',
        // 期望职务
        expectedPosition: '',
        // 期望省份
        expectedProvince: '',
        // 头像
        headPortrait: '',
        headPortraits: '',
        // 	业界荣誉
        honor: '',
        // 月薪或者年薪0->月薪；1->年薪
        isAnnual: 0,
        // 目前薪资0->年；1->月
        isYears: 0,
        // 求职渠道
        jobChannels: '',
        // 语言能力
        languageAbility: '',
        // 所在行业集合
        listCurrentIndustry: [],
        listEducationBackground: [],
        listHonor: [],
        listLanguageAbility: [],
        listPersonalGlory: [],
        listTechnique: [],
        // 邮件
        mail: '',
        // 姓名
        name: '',
        // 	其他
        other: '',
        // 所在城市
        personCity: '',
        // 人才编号
        personCode: '',
        // 所在国家
        personCountry: '',
        // 工作经历详情
        personDetailsWorkExperiences: [
          {
            companyName: '',
            createName: '',
            createTime: '',
            department: '',
            id: 0,
            inductionTime: '',
            personnelCode: '',
            position: '',
            quitTime: '',
            reportingObject: '',
            salaryExpectation: '',
            salaryExpectationEnd: '',
            updateName: '',
            updateTime: ''
          }
        ],
        // 教育经历（时间倒叙）
        personEducational: [
          {
            createName: '',
            createTime: '',
            education: '',
            endDate: '',
            id: 0,
            major: '',
            personCode: '',
            schoolName: '',
            startDate: '',
            updateName: '',
            updateTime: '',
            cityName: ''
          }
        ],
        // 工作经历（时间倒叙）
        personExperience: [
          {
            companyName: '',
            createName: '',
            createTime: '',
            id: 0,
            inductionTime: '',
            jobPerformance: '',
            number: 0,
            operatingDuty: '', // 职位描述
            personnelCode: '',
            position: '',
            quitTime: '',
            updateName: '',
            updateTime: '',
            reasonsLeaving: '' // 离职原因
          }
        ],
        // 项目经历（时间倒叙）
        personProjectExperience: [
          {
            createName: '',
            createTime: '',
            endTime: '',
            id: 0,
            personCode: '',
            projectAchievement: '',
            projectFunction: '',
            projectName: '',
            projectPerformance: '',
            startTime: '',
            updateName: '',
            updateTime: ''
          }
        ],
        // 所在省份/直辖市
        personProvince: '',
        // 职位类型
        personType: '',
        // 个人荣耀标签
        personalGlory: '',
        // 联系电话
        phone: '',
        // 期望薪资(起)
        salaryExpectation: '',
        // 期望薪资(始)
        salaryExpectationEnd: '',
        // 	自我评价
        selfAssessment: '',
        // 性别
        sex: '',
        // 来源
        source: '',
        // 目前状态
        state: '',
        // 我的技能
        technique: '',
        // 时间选择0->1个月;1->随时
        timeChoose: 0,
        // 修改人名字
        updateName: '',
        // 	修改时间
        updateTime: '',
        // 职业培训
        vocationalTrainings: [
          {
            address: '',
            createName: '',
            createTime: '',
            endTime: '',
            id: 0,
            personnelCode: '',
            startTime: '',
            trainingContent: '',
            trainingTopics: '',
            updateName: '',
            updateTime: ''
          }
        ],
        // 微信
        weChat: '',
        // 	是否结婚0->已婚;1->未婚
        weddingOrNot: 0,
        // 工作经验/工作年限
        workingYears: ''
      },
      // 工作经历及内容 添加模板
      personExperienceList: {
        companyName: '',
        createName: '',
        createTime: '',
        id: 0,
        inductionTime: '',
        jobPerformance: '',
        number: 0,
        operatingDuty: '', // 职位描述
        personnelCode: '',
        position: '',
        quitTime: '',
        updateName: '',
        updateTime: '',
        reasonsLeaving: '' // 离职原因
      },
      personProjectExperienceList: {
        createName: '',
        createTime: '',
        endTime: '',
        id: 0,
        personCode: '',
        projectAchievement: '',
        projectFunction: '',
        projectName: '',
        projectPerformance: '',
        startTime: '',
        updateName: '',
        updateTime: ''
      },
      personExperience: {}, // 工作经历  取消的时候要用到
      personExperienceTwo: {},
      personProjectExperience: {},
      personProjectExperienceTwo: {},
      // 技术能力
      inputVisibleTech: false,
      inputValueTech: '',

      vocationalTrainingsList: {
        address: '',
        createName: '',
        createTime: '',
        endTime: '',
        id: 0,
        personnelCode: '',
        startTime: '',
        trainingContent: '',
        trainingTopics: '',
        updateName: '',
        updateTime: ''
      },
      vocationalTrainingsShow: false,
      vocationalTrainings: {},
      vocationalTrainingsTwo: {},
      editWorkExperience: true, // 编辑工作经历
      // 人才推荐报告---把人才评估、目前薪资、期望薪资、入职时间设置成必填项
      ruleForm: {
        entryTime: [{ required: true, message: '请输入入职时间', trigger: 'blur' }]
        // sex: [{ required: true, message: '请选择用户性别', trigger: 'change' }],
        // permissions: [
        //   {
        //     required: true,
        //     message: '请至少选择一个权限模块',
        //     trigger: 'change'
        //   }
        // ]
      }
    }
  },

  watch: {},

  methods: {
    onBack() {
      if (this.$route.query.tabType && this.$route.query.tabType == '1') {
        this.$router.replace({
          path: '/businessManagement/JingyiProject',
          query: { tabType: 1 }
        })
      } else {
        this.$router.back()
      }
    },
    onChangeSelectByidObj(value, fieldName) {
      this.selectByidObj[fieldName] = value
    },
    //人才评估校验
    validatorEvaluation(rules, value, callback) {
      if (!value) {
        callback('请输入人才评估')
      }
      callback()
    },
    //校验目前薪资信息
    validatorCurSalaryItems(rules, callback) {
      const {
        currentSalary,
        currentMonthlySalary,
        currentAnnualBonus,
        currentPerformanceBonus,
        currentPercentage,
        currentOther
      } = this.selectByidObj
      if (
        currentSalary &&
        currentMonthlySalary &&
        currentAnnualBonus &&
        currentPerformanceBonus &&
        currentPercentage &&
        currentOther
      ) {
        callback()
      } else {
        callback('请将目前薪资信息填写完整')
      }
      callback()
    },
    //校验期望薪资信息
    validatorExpectationtems(rules, callback) {
      const {
        salaryExpectation,
        salaryMonthlySalary,
        salaryAnnualBonus,
        salaryPerformanceBonus,
        salaryPercentage,
        salaryOther
      } = this.selectByidObj
      if (
        salaryExpectation &&
        salaryMonthlySalary &&
        salaryAnnualBonus &&
        salaryPerformanceBonus &&
        salaryPercentage &&
        salaryOther
      ) {
        callback()
      } else {
        callback('请将期望薪资信息填写完整')
      }
      callback()
    },

    // -------------------------
    pendingRes(event) {
      if (event.target.tagName === 'INPUT') {
        let id = event.target.value
        if (this.info != id) {
          this.auditingDisabled = true
          this.auditingNoRules.rejectionReason[0].required = false
          this.auditingNoRules.rejectionReason[0].message = ''
        } else {
          this.auditingDisabled = false
          this.auditingNoRules.rejectionReason[0].required = true
          this.auditingNoRules.rejectionReason[0].message = '请选择驳回理由'
          this.info = 0
        }
      }
    },
    //选中审核不通过改变事件
    rejectionReasonChange(val) {
      if (val) {
        this.rejectionDisabled = true
      } else {
        this.rejectionDisabled = false
      }
    },
    // 关闭审核不通过弹窗
    handleCloseA(done) {
      // this.auditingNoDialogVisible = false
      // this.auditingNoForm = {}
      this.auditingNoDialogVisible = false
      this.info = 0
      this.auditingDisabled = false
      this.rejectionDisabled = false
      this.auditingNoForm = {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      }
      this.auditingNoRules.rejectionReason[0].require = false
      this.search()
      done()
      // this.personListSearch()
      // this.getPersonReview()
    },
    // 查询拒绝理由
    async getRejectionType() {
      const { data } = await rejectionType({
        type: '024'
      })
      if (data.resultCode == 200) {
        this.options = data.data
      }
    },
    //审核通过
    async auditingNoY() {
      const { data: res } = await agree({
        reviewCode: this.reviewCode
      })
      if (res.resultCode == 200) {
        this.$message.success('审核成功')
        this.search()
        // this.$router.push({
        //   path: '/businessManagement/JingyiProject'
        // })
      }
    },
    // 打开审核不通过弹窗
    auditingNo() {
      this.auditingNoDialogVisible = true
    },
    // 关闭审核不通过弹窗
    handleClose(done) {
      this.auditingNoDialogVisible = false
      this.info = 0
      this.auditingDisabled = false
      this.rejectionDisabled = false
      this.auditingNoForm = {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      }
      this.auditingNoRules.rejectionReason[0].require = false
      this.search()
      // this.personListSearch()
      // this.getPersonReview()
    },
    // 审核不通过弹窗保存
    async auditingNoFn() {
      // this.auditingNoForm.reviewCode = this.reviewCode
      // const { data } = await reject(this.auditingNoForm)
      // if (data.resultCode == 200) {
      //   this.$message.success(data.message)
      //   this.auditingNoDialogVisible = false
      //   this.search()
      //   this.$router.push({
      //     path: '/businessManagement/JingyiProject'
      //   })
      // }

      this.auditingNoForm.reviewCode = this.reviewCode
      const { data } = await reject(this.auditingNoForm)
      if (data.resultCode == 200) {
        this.$message.success(data.message)
        this.auditingNoDialogVisible = false
        this.info = 0
        this.auditingDisabled = false
        this.rejectionDisabled = false
        this.auditingNoRules.rejectionReason[0].require = false
        this.auditingNoForm = {
          rejectionReason: '', //驳回理由
          rejectionType: '', //驳回理由类型（自定义）
          reviewCode: '' //审核编号审核编号
        }
        this.search()
        this.$router.push({
          path: '/businessManagement/JingyiProject'
        })
        // this.personListSearch()
        // this.getPersonReview()
      }
    },
    // 查询基本信息
    async search() {
      let PreCode = this.PreCode
      const { data: res } = await getParticularsPersonByid({
        PreCode,
        projectId: this.projectId
      })
      if (res.resultCode == 200) {
        this.form = res.data
        this.newForm(res.data)
        this.basicInfoObj.recruitmentPosition = res.data.recruitmentPosition
        this.basicInfoObj.corporateName = res.data.corporateName
        this.basicInfoObj.projectConsultant = res.data.projectConsultant
      }
    },
    newForm(val) {
      if (val.other) {
        this.selectByidObj.talentEvaluation = val.other
      }
      // 期望薪资
      // if (val.currentSalaryStart && val.currentSalaryEnd) {
      //   this.selectByidObj.salaryExpectation = val.currentSalaryStart + '-' + val.currentSalaryEnd
      // } else {
      //   this.selectByidObj.salaryExpectation = val.currentSalaryStart
      // }
      if (val.currentSalaryStart && val.currentSalaryEnd) {
        this.selectByidObj.currentSalary = val.currentSalaryStart + '-' + val.currentSalaryEnd
      } else {
        this.selectByidObj.currentSalary = val.currentSalaryStart
      }
      // 当前薪资
      // if (val.salaryExpectation && val.salaryExpectationEnd) {
      //   this.selectByidObj.currentSalary = val.salaryExpectation + '-' + val.salaryExpectationEnd
      // } else {
      //   this.selectByidObj.currentSalary = val.salaryExpectation
      // }
      if (val.salaryExpectation && val.salaryExpectationEnd) {
        this.selectByidObj.salaryExpectation =
          val.salaryExpectation + '-' + val.salaryExpectationEnd
      } else {
        this.selectByidObj.salaryExpectation = val.salaryExpectation
      }
      this.form = {
        ...val,
        selectByidObj: {
          talentEvaluation: val.other,
          curSalaryItems: '',
          salaryExpectationItems: ''
        }
      }
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // 人才的id
          // console.log(this.PreCode)
          // 学校地点名字
          // console.log(this.form.personEducational[0].cityName);
          // const mycityName = this.form.personEducational[0].cityName
          const mycreateName = this.form.name
          // console.log(this.item)
          // console.log(this.selectByidObj)
          if (this.btnClickCount.save === 0) {
            this.btnClickCount.save++
            this.selectByidObj.personnelId = this.PreCode
            this.selectByidObj.projectId = this.item.projectId
            // console.log(...this.selectByidObj, mycityName,this.PreCode)
            // { ...this.selectByidObj, cityName: mycityName, personCode: this.PreCode }
            const { data: res } = await addTalentRecommend({
              ...this.selectByidObj,
              personCode: this.PreCode,
              createName: mycreateName,
              personExperience: this.form.personExperience
            })
            if (res.resultCode == 200) {
              setTimeout(() => {
                this.btnClickCount.save = 0
              }, 2000)
              console.log('form数据', this.form.personExperience)
              this.$message.success('保存成功')
              this.$router.go(-1)
            }
            if (this.$route.query.tabType && this.$route.query.tabType == 1) {
           
              this.$router.push({
                path: '/businessManagement/JingyiProject',
                query: {
                  tabType: '1'
                }
              })
            } else {
              this.$router.back()
            }
          }
        } else {
          return false
        }
      })
    },
    // 菁亿项目-人选-推荐报告-下载报告
    async download() {
      if (this.btnClickCount.download === 0) {
        this.btnClickCount.download++
        this.selectByidObj.personnelId = this.PreCode
        this.selectByidObj.projectId = this.item.id
        const { data: res } = await addTalentRecommend({
          ...this.selectByidObj,
          personCode: this.PreCode,
          projectId: Number(this.projectId)
        })
        if (res.resultCode == 200) {
          setTimeout(() => {
            this.btnClickCount.download = 0
          }, 2000)
          const { data: resS } = await reportDownLoad({
            personCode: this.PreCode,
            projectId: this.item.projectCode,
            id: this.item.projectId
          })
          if (resS) {
            let blob = new Blob([resS])
            let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
            const a = document.createElement('a') //创建a标签
            a.style.display = 'none'
            a.href = href // 指定下载'链接
            //人才推荐报告.doc
            a.download = `${'人才报告-' + this.form.name + '-' + this.basicInfoObj.recruitmentPosition + '.doc'
              }` //指定下载文件名
            // a.download = "test.png";
            a.click() //触发下载
            window.URL.revokeObjectURL(a.href) //释放URL对象
            if (document.body.contains(a)) {
              document.body.removeChild(a) //释放标签
            }
            //  else {
            //   this.$message.error('导出失败!')
            // }
          }
        }
      } else if (this.btnClickCount.download === 1) {
        this.$message.warning('请勿频繁点击~')
      }
    },
    async getSelectByid() {
      let id = this.item.personEducational.id
      let projectId = this.item.personCode
      const { data: res } = await selectByid({ id, projectId })
      if (res.resultCode == 200) {
        if (res.data != null) {
          // this.selectByidObj = res.data
          Object.assign(this.selectByidObj, res.data)
        }
      }
    },
    showInputTech() {
      this.inputVisibleTech = true
      this.$nextTick(() => {
        this.$refs.saveTagInputTech.$refs.input.focus()
      })
    },
    //打开工作经历
    clickAddPersonDetailsWorkExperiences() {
      this.personExperienceShow = true
    },
    openVocationalTrainingsShow() {
      this.vocationalTrainingsShow = true
    },
    addPersonProjectExperience() {
      this.addPersonProjectExperienceShow = true
    },
    // 编辑完成工作经历
    clickAccomplish() {
      let i = this.form.personExperience.indexOf(this.personExperience)
      // 如果不等于-1  那么说明是编辑 要修改里面的旧数据
      if (i != -1) {
        this.form.personExperience[i] = this.personExperience
        // console.log("form数据",this.form.personExperience)
      } else {
        // 这个是点击新增后的编辑
        this.form.personExperience.push(this.personExperienceList)
      }
      this.personExperienceList = {
        companyName: '',
        createName: '',
        createTime: '',
        id: 0,
        inductionTime: '',
        jobPerformance: '',
        number: 0,
        operatingDuty: '', // 职位描述
        personnelCode: '',
        position: '',
        quitTime: '',
        updateName: '',
        updateTime: ''
      }
      this.personExperienceTwo = {}
      this.personExperience = {}
      this.personExperienceShow = false
      this.editWorkExperience = true
    },
    clickAccomplishTwo() {
      let i = this.form.personProjectExperience.indexOf(this.personProjectExperience)
      // 如果不等于-1  那么说明是编辑 要修改里面的旧数据
      if (i != -1) {
        console.log(this.personExperienceTwo)
        this.form.personProjectExperience[i] = this.personProjectExperience
      } else {
        // 这个是点击新增后的编辑
        this.form.personProjectExperience.push(this.personProjectExperienceList)
      }
      this.personProjectExperienceList = {
        createName: '',
        createTime: '',
        endTime: '',
        id: 0,
        personCode: '',
        projectAchievement: '',
        projectFunction: '',
        projectName: '',
        projectPerformance: '',
        startTime: '',
        updateName: '',
        updateTime: ''
      }
      this.personProjectExperienceTwo = {}
      this.personProjectExperience = {}
      this.addPersonProjectExperienceShow = false
    },
    clickVocationalTrainings() {
      let i = this.form.vocationalTrainings.indexOf(this.vocationalTrainings)
      // 如果不等于-1  那么说明是编辑 要修改里面的旧数据
      if (i != -1) {
        this.form.vocationalTrainings[i] = this.vocationalTrainings
      } else {
        // 这个是点击新增后的编辑
        this.form.vocationalTrainings.push(this.vocationalTrainingsList)
      }
      this.vocationalTrainingsList = {
        createName: '',
        createTime: '',
        endTime: '',
        id: 0,
        personCode: '',
        projectAchievement: '',
        projectFunction: '',
        projectName: '',
        projectPerformance: '',
        startTime: '',
        updateName: '',
        updateTime: ''
      }
      this.vocationalTrainingsTwo = {}
      this.vocationalTrainings = {}
      this.vocationalTrainingsShow = false
    },
    clickCancelTwo() {
      this.addPersonProjectExperienceShow = false
      this.editWorkExperience = true
      // 点击编辑进来的  判断为true  那么说明是点击编辑进来的
      if (JSON.stringify(this.personProjectExperience) != '{}') {
        let i = this.form.personProjectExperience.indexOf(this.personProjectExperience)
        this.form.personProjectExperience[i] = this.personProjectExperienceTwo
        this.personProjectExperienceTwo = {}
        this.personProjectExperience = {}
        this.personProjectExperienceList = {
          companyName: '',
          createName: '',
          createTime: '',
          id: 0,
          inductionTime: '',
          jobPerformance: '',
          number: 0,
          operatingDuty: '', // 职位描述
          personnelCode: '',
          position: '',
          quitTime: '',
          updateName: '',
          updateTime: ''
        }
      } else {
        // 点击新增进来的
        this.personProjectExperienceList = {
          companyName: '',
          createName: '',
          createTime: '',
          id: 0,
          inductionTime: '',
          jobPerformance: '',
          number: 0,
          operatingDuty: '', // 职位描述
          personnelCode: '',
          position: '',
          quitTime: '',
          updateName: '',
          updateTime: ''
        }
      }
    },
    clickVocationalTrainingsTwo() {
      this.vocationalTrainingsShow = false
      // 点击编辑进来的  判断为true  那么说明是点击编辑进来的
      if (JSON.stringify(this.vocationalTrainings) != '{}') {
        let i = this.form.vocationalTrainings.indexOf(this.vocationalTrainings)
        this.form.vocationalTrainings[i] = this.vocationalTrainingsTwo
        this.vocationalTrainingsTwo = {}
        this.vocationalTrainings = {}
        this.vocationalTrainingsList = {
          address: '',
          createName: '',
          createTime: '',
          endTime: '',
          id: 0,
          personnelCode: '',
          startTime: '',
          trainingContent: '',
          trainingTopics: '',
          updateName: '',
          updateTime: ''
        }
      } else {
        // 点击新增进来的
        this.vocationalTrainingsList = {
          address: '',
          createName: '',
          createTime: '',
          endTime: '',
          id: 0,
          personnelCode: '',
          startTime: '',
          trainingContent: '',
          trainingTopics: '',
          updateName: '',
          updateTime: ''
        }
      }
    },
    // 取消工作经历
    clickCancel() {
      this.personExperienceShow = false
      this.editWorkExperience = true
      // 点击编辑进来的  判断为true  那么说明是点击编辑进来的
      if (JSON.stringify(this.personExperience) != '{}') {
        let i = this.form.personExperience.indexOf(this.personExperience)
        this.form.personExperience[i] = this.personExperienceTwo
        this.personExperienceTwo = {}
        this.personExperience = {}
        this.personExperienceList = {
          companyName: '',
          createName: '',
          createTime: '',
          id: 0,
          inductionTime: '',
          jobPerformance: '',
          number: 0,
          operatingDuty: '', // 职位描述
          personnelCode: '',
          position: '',
          quitTime: '',
          updateName: '',
          updateTime: ''
        }
      } else {
        // 点击新增进来的
        this.personExperienceList = {
          companyName: '',
          createName: '',
          createTime: '',
          id: 0,
          inductionTime: '',
          jobPerformance: '',
          number: 0,
          operatingDuty: '', // 职位描述
          personnelCode: '',
          position: '',
          quitTime: '',
          updateName: '',
          updateTime: ''
        }
      }
    },

    // 编辑当前工作经历
    clickRedactPersonExperience(item, index) {
      this.personExperienceList = item
      let obj = JSON.stringify(item)
      this.personExperienceTwo = JSON.parse(obj)
      this.personExperience = item
      this.personExperienceShow = true
      this.editWorkExperience = false
    },

    clickRedactPersonProjectExperience(item, index) {
      this.personProjectExperienceList = item
      let obj = JSON.stringify(item)
      this.personProjectExperienceTwo = JSON.parse(obj)
      this.personProjectExperience = item
      this.addPersonProjectExperienceShow = true
    },

    clickRedactPersonVocationalTrainings(item, index) {
      this.vocationalTrainingsList = item
      let obj = JSON.stringify(item)
      this.vocationalTrainingsTwo = JSON.parse(obj)
      this.vocationalTrainings = item
      this.vocationalTrainingsShow = true
    },
    // 删除当前工作经历
    clickRemovePersonExperience(item, index) {
      this.form.personExperience.splice(index, 1)
    },
    clickRemovePersonProjectExperience(item, index) {
      this.form.personProjectExperience.splice(index, 1)
    },
    clickRemoveVocationalTrainings(item, index) {
      this.form.vocationalTrainings.splice(index, 1)
    },
    //
    clickAddPersonEducationalItem(item, index) {
      this.form.personEducational.push({
        createName: '',
        createTime: '',
        education: '',
        endDate: '',
        id: 0,
        major: '',
        personCode: '',
        schoolName: '',
        startDate: '',
        updateName: '',
        updateTime: '',
        cityName: ''
      })
    },
    clickRemovePersonEducationalItem(item, index) {
      this.form.personEducational.splice(index, 1)
    },
    addCertifications() {
      this.form.certifications.push({
        address: '',
        certificateName: '',
        createName: '',
        createTime: '',
        endTime: '',
        id: 0,
        personnelCode: '',
        startTime: '',
        updateName: '',
        updateTime: ''
      })
    },
    removeCertifications(item, index) {
      this.form.certifications.splice(index, 1)
    },
    // 我的技能
    handleCloseTech(tag) {
      this.form.listTechnique.splice(this.form.listTechnique.indexOf(tag), 1)
    },
    handleInputConfirmTech() {
      let inputValue = this.inputValueTech
      if (inputValue) {
        this.form.listTechnique.push(inputValue)
      }
      this.inputVisibleTech = false
      this.inputValueTech = ''
    }
  }
}
</script>

<style lang="less" scoped>
.referenceCheck {
  background: #fff;
  padding: 20px 16px;
  position: relative;

  .form_content {
    height: calc(100vh - 208px - 72px);
    overflow: auto;
    padding-bottom: 72px;
  }

  .title_main {
    display: flex;
    align-items: center;

    margin-bottom: 20px;

    .line {
      width: 4px;
      height: 18px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 4px;
    }

    .title_main_txt {
      font-size: 15px;
      font-weight: 600;
      color: #17757a;
    }

    .add_item {
      display: flex;
      flex: 1;
      flex-direction: row-reverse;
      padding-right: 320px;
      cursor: pointer;
      margin-right: 8px;

      .add_item_box {
        display: flex;

        .add_icon {
          margin-right: 4px;
        }

        .add_txt {
          font-size: 14px;
          color: #17757a;
        }
      }
    }
  }

  .personal_information {
    display: flex;
    width: 1024px;
    flex-wrap: wrap;

    .personal_information_name {
      width: 197px;
    }

    .personal_information_age {
      width: 197px;
    }

    .personal_information_lang {
      width: 261px;
    }

    /deep/.el-radio__inner {
      width: 16px;
      height: 16px;
    }

    // .CascaderArea {
    // }
  }

  // 人才评估
  .talent_evaluation {
    /deep/.el-form-item__content {
      margin-left: 60px !important;
      width: 100%;
      // height: 114px;
    }
  }

  //教育背景
  .educational_background {
    .educational_background_item {
      display: flex;
      align-items: center;
      margin-bottom: 21px;
      margin-left: 60px;

      /deep/.el-form-item {
        margin: 0;
      }

      /deep/.el-form-item__content {
        margin-left: 0 !important;
      }

      .start_time {
        /deep/.el-input__inner {
          width: 220px;
        }
      }

      .end_time {
        margin-right: 8px;

        /deep/.el-input__inner {
          width: 220px;
        }
      }

      .school {
        margin-right: 8px;

        /deep/.el-input__inner {
          width: 266px;
        }
      }

      .degree {
        margin-right: 8px;

        /deep/.el-input__inner {
          width: 138px;
        }
      }

      .specialty {
        /deep/.el-input__inner {
          width: 233px;
        }

        margin-right: 28px;
      }

      .options_item {
        display: flex;

        .add_item {
          display: flex;
          cursor: pointer;
          margin-right: 8px;

          .add_icon {
            margin-right: 4px;
          }

          .add_txt {
            font-size: 14px;
            color: #17757a;
          }
        }

        .remove_item {
          display: flex;
          cursor: pointer;

          .remove_icon {
            margin-right: 4px;
          }

          .remove_txt {
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
  }

  // 工作经历及内容
  .work_experience_content {
    .work_experience_content_item {
      border: 1px solid #e5e5e5;
      border-radius: 2px;
      //width: 100%;
      margin-left: 60px;
      padding-left: 11px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      .head_time {
        height: 47px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;

        .head_time_box {
          height: 47px;
          display: flex;
          align-items: center;

          .times {
            min-width: 120px;
            font-size: 12px;
            font-weight: 400;
            color: #b2b2b2;
            margin-right: 24px;
          }

          .name {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
          }
        }

        .head_time_option {
          display: flex;
        }
      }

      .content {
        flex: 1;
        display: flex;
        align-items: center;

        .label {
          min-width: 120px;
          margin-right: 24px;
          font-size: 12px;
          font-weight: 600;
          color: #333333;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .content_right {
          .content_position {
            margin-bottom: 8px;
          }

          .operatingDuty {
            color: #333333;
            font-size: 12px;
          }
        }
      }
    }

    .add_personExperience {
      width: 1294px;

      margin-left: 60px;
      background-color: #fafdfb;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 14px 29px 20px 20px;

      /deep/.el-form-item__content {
        margin-left: 0 !important;
      }

      .add_personExperience_head {
        display: flex;
        width: 100%;
        justify-content: space-between;

        /deep/.el-form-item__content {
          margin-left: 0 !important;
          display: flex;
        }
      }

      .add_personExperience_center {
        /deep/.el-form-item {
          display: flex;
        }

        /deep/.el-form-item__content {
          flex: 1;
        }

        /deep/.el-textarea__inner {
          min-height: 139px !important;
          height: 139px;
          box-sizing: border-box;
        }
      }

      .add_personExperience_option {
        display: flex;
        flex-direction: row-reverse;
        margin-top: 30px;

        padding-right: 65px;

        .accomplish {
          width: 64px;
          height: 28px;
          display: flex;
          font-size: 14px;
          border-radius: 2px;
          align-items: center;
          justify-content: center;
          background-color: #17757a;
          color: #fff;
          cursor: pointer;
          margin-right: 18px;
        }

        .cancel {
          width: 64px;
          height: 28px;
          border: 1px solid #17757a;
          display: flex;
          box-sizing: border-box;
          font-size: 14px;
          color: #17757a;
          border-radius: 2px;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
  }

  // 部分项目
  .some_projects {
    width: 100%;

    /deep/.el-form-item__content {
      margin-left: 60px !important;
      width: 100%;
      // height: 114px;
    }
  }

  // 薪资待遇
  .current_salary {
    .new_left {
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .menony_flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .menony_flex_item {
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            display: block;
            color: #606266;
            font-size: 14px;
            width: 82px;
            text-align: right;
          }

          /deep/ .el-input {
            width: 211px;
          }
        }

        .menony_flex_left {
          margin-right: 40px;
          overflow: hidden;
          width: 18%;
        }

        .menony_flex_center {
          transform: translateY(-13px);
          width: 12%;
          margin-right: 40px;
          font-size: 14px;
          align-items: center;
          color: #000;
          display: flex;
          flex-direction: column;

          /deep/ span {
            line-height: 20px !important;
          }

          div {
            width: 100%;
            position: relative;
            height: 2px;
            margin-top: 8px;
            background-color: #eee;
          }

          div:before {
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -4px;
            content: ' ';
            display: inline-block;
            height: 6px;
            width: 6px;
            border-width: 2px 2px 0 0;
            border-color: #c8c8cd;
            border-style: solid;
            -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
            transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
          }

          div:after {
            content: ' ';
            position: absolute;
            right: 0;
            top: 0;
            width: 1px;
            bottom: 0;
            border-right: 1px solid #d9d9d9;
            color: #d9d9d9;
            -webkit-transform-origin: 100% 0;
            transform-origin: 100% 0;
            -webkit-transform: scaleX(0.5);
            transform: scaleX(0.5);
          }
        }

        .menony_flex_right {
          flex: 1;
          overflow: hidden;

          /deep/ .el-input {
            width: 184px !important;
          }

          .menony_flex_right_li {
            display: flex;
            flex-direction: row;
            margin-bottom: 20px;
          }

          .menony_flex_right_li_item {
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;

            span {
              display: block;
              color: #606266;
              font-size: 14px;
              width: 80px;
              text-align: right;
            }

            /deep/.el-textarea__inner {
              width: 592px;
            }

            /deep/.el-textarea {
              width: 592px;
            }
          }
        }
      }
    }
  }

  .entryTime {
    /deep/.el-form-item__content {
      display: flex;
    }

    /deep/.el-radio-button {
      margin-right: 10px;
    }

    /deep/ .el-radio-button__inner {
      border: 1px solid #17757a !important;
      padding: 10px 10px;
    }

    /deep/ .el-radio-button__inner:hover {
      color: #17757a;
      background-color: #fff;
    }

    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      background-color: #17757a;
      color: #fff;
      border: 1px solid #17757a !important;
      box-shadow: none;
    }

    /deep/ .el-radio-button.is-checked .el-radio-button__inner {
      box-shadow: none;
    }
  }

  .option_button {
    display: flex;
    margin-top: 50px;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 72px;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    box-shadow: 0px 0px 4px 0px #00000040;

    .save {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      background-color: #17757a;
      margin-right: 10px;
      cursor: pointer;
    }

    .download {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      margin-right: 10px;
      background-color: #17757a;
      cursor: pointer;
    }

    .back {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #17757a;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      border: 1px solid #17757a;
      cursor: pointer;
    }
  }
}

// 样式星号
.star_style::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
</style>
